<template>
  <div>
    <span id="ProgressLabel" class="sr-only">Loading</span>
    <span
      role="progressbar"
      aria-labelledby="ProgressLabel"
      :aria-valuenow="(value * 100) / max"
      class="progressbar"
    >
      <div :style="{ width: (value / max) * 100 + '%', transition: 'width 3s linear' }">
        <span
          class="progress-bar"
          :style="{ backgroundColor: renderColor, transition: 'all 0.5s ease'}"
        >
          <app-count-up
            :start-val="0"
            :end-val="value"
            :duration="3000"
            class-name="progress-text"
            @on-value-changed="(val) => process = val"
          >%</app-count-up>
        </span>
      </div>
    </span>
  </div>
</template>

<script>
import AppCountUp from '@/components/app-count-up/';

export default {
  name: 'AppProgress',
  components: { AppCountUp },
  props: {
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      process: 0,
    };
  },
  computed: {
    renderColor() {
      if (this.process === this.max) {
        return '#005DCA';
      } else if (this.process < 30) {
        return '#FF867E';
      } else if (this.process <= 60) {
        return '#FFC226';
      }
      return '#00B57F';
    },
  },
};
</script>

<style lang="scss">
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.progressbar {
  display: block;
  border-radius: 9999px;
  background-color: #FFFFFF;
}

.progress-bar {
  height: 14px;
  border-radius: 9999px;
  text-align: center;
  font-size: 10px;
  line-height: 16px;
  animation: animate 3s linear forwards;
}

.progress-text {
  font-weight: bold;
  color: white;
}

@keyframes animate {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app-progress/index.vue